import { useMainStore } from "@/store";

export class ACL {
	static isAdmin() {
		return useMainStore().is_admin;
	}
	static isExternal() {
		return useMainStore().is_external;
	}
	static isClient() {
		return useMainStore().is_client;
	}
	static isFacebook() {
		const username = useMainStore().username;
		return username === "facebook" || username === "__f_acebook_old";
	}
	static canAccessRoute(routeName) {
		if (this.isFacebook()) {
			const allowedRoutes = ["Dashboards List Page", "Custom Dashboard Page"];
			return allowedRoutes.includes(routeName);
		}
		return true;
	}
	static getState() {
		let state = "admin";
		if (this.isExternal() && !this.isClient()) {
			state = "external";
		} else if (this.isClient()) {
			state = "client";
		}
		return state;
	}
}
